import { types } from '../types/types';

const initialState = {
  typesCatalog: [],
  items: [],
  loading: false,
};

export const homeContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.HOME_CONTENT_SET_LOADING:
      return { ...state, loading: !!action.payload };
    case types.HOME_CONTENT_SET_TYPES:
      return { ...state, typesCatalog: action.payload || [], loading: false };
    case types.HOME_CONTENT_SET_ITEMS:
      return { ...state, items: action.payload || [], loading: false };
    default:
      return state;
  }
};
